import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { uniqueId } from 'lodash';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellListItems: ComponentWithProps<Props>;
  }
}

/**
 * `TableCellListItems` component properties.
 */
export interface Props {
  /** ... */
  value: unknown[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableCellListItems',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  /** ... */
  value: unknown[];
};



const items = computed(() => {
  return props.value.map((item) => ({ key: uniqueId(), item }));
});

return { __sfc: true,props, items }
}

})